import React, { FC } from 'react'

import { IconMailProps } from './IconMail.types'
import * as Styled from './styles/IconMail.style'

import { nonThemeableRules } from '../../ruleSet'

const IconMail: FC<IconMailProps> = ({
  size = nonThemeableRules.defaultSize as number as IconMailProps['size'],
  isResponsive = false,
}: IconMailProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <g
          clipPath='url(#ef35a350-58ca-4fa3-8935-32ec8a6af0fd__a)'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        >
          <path d='M40.263 13.853 26.513 28.02a3.728 3.728 0 0 1-5.386 0L8.264 14.383' />
          <path d='M11 13a4 4 0 0 0-4 4v15a4 4 0 0 0 4 4h26a4 4 0 0 0 4-4V13H11Z' />
        </g>
        <defs>
          <clipPath id='ef35a350-58ca-4fa3-8935-32ec8a6af0fd__a'>
            <path d='M0 0h48v48H0z' fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconMail
